import { MigrationSpec } from "../migration.models"

const aiEmailSettings: MigrationSpec = {
  type: "MIGRATE_AI_EMAIL_SETTINGS",
  collection: "AiProfile",
  risk: "DESTRUCTIVE",
  title: {
    en: "Non-ticket e-mail → its own emailSettings block",
    tr: "Ticket olmayan e-posta → kendi emailSettings bloğu"
  },
  description: {
    en:
      "Gives every Service and E-commerce profile without one an `emailSettings` block: a copy of " +
      "`chatSettings` restricted to the e-mail accounts in `chatSettings.channels` (without " +
      "`humanHandoff`, which e-mail does not have), or `{}` — schema defaults, AI off — when chat had " +
      "no e-mail account. In the same write it pulls those e-mail account ids out of " +
      "`chatSettings.channels` and `chatSettings.humanHandoff.channels`. E-mail tickets keep " +
      "`ticketSettings`.",
    tr:
      "`emailSettings` bloğu olmayan her Hizmet ve E-ticaret profiline bu bloğu verir: " +
      "`chatSettings`'in `chatSettings.channels` içindeki e-posta hesaplarıyla sınırlanmış bir " +
      "kopyası (`humanHandoff` hariç; e-postada bu ayar yoktur), chat'te hiç e-posta hesabı " +
      "yoksa `{}` — şema varsayılanları, AI kapalı. Aynı yazımda bu e-posta hesap kimliklerini " +
      "`chatSettings.channels` ve `chatSettings.humanHandoff.channels` listelerinden çıkarır. " +
      "E-posta ticket'ları `ticketSettings` ile kalır."
  },
  affectedFilter: {
    role: { $in: ["SERVICE", "ECOMMERCE"] },
    emailSettings: { $exists: false }
  },
  sampleFields: [
    "customer",
    "role",
    "chatSettings.status",
    "chatSettings.channels",
    "updatedAt"
  ],
  preview: (doc) => {
    const chatSettings =
      (doc.chatSettings as Record<string, unknown> | undefined) ?? {}
    const channels = (chatSettings.channels as string[] | undefined) ?? []
    if (!channels.length) {
      return { ...doc, emailSettings: {} }
    }
    // Which ids are e-mail accounts is only known server-side.
    return {
      ...doc,
      chatSettings: {
        ...chatSettings,
        channels: ["… without the e-mail accounts"]
      },
      emailSettings: {
        ...chatSettings,
        channels: ["… only the e-mail accounts ({} if there are none)"]
      }
    }
  },
  notes: [
    {
      en:
        "DESTRUCTIVE: the e-mail account ids are removed from the chat block. Rolling qpien-ai " +
        "or api-v2 back to a build without `emailSettings` after this has run stops AI answering " +
        "e-mail — that code looks for them in `chatSettings.channels`.",
      tr:
        "YIKICI: e-posta hesap kimlikleri chat bloğundan silinir. Bu çalıştıktan sonra qpien-ai " +
        "veya api-v2 `emailSettings` bilmeyen bir sürüme geri alınırsa AI e-postaları " +
        "cevaplamayı bırakır — o kod onları `chatSettings.channels` içinde arar."
    },
    {
      en:
        "Nothing changes for a tenant before the run: qpien-ai reads `chatSettings` as the " +
        "e-mail block of a profile that has no `emailSettings` yet.",
      tr:
        "Çalışmadan önce tenant için hiçbir şey değişmez: qpien-ai, henüz `emailSettings` bloğu " +
        "olmayan profilde e-posta bloğu olarak `chatSettings`'i okur."
    },
    {
      en:
        "Run right after qpien-ai and api-v2 are deployed and BEFORE the new user-panel goes out: " +
        "its chat page no longer offers e-mail accounts, so a chat block saved there first may " +
        "lose them before they are copied.",
      tr:
        "qpien-ai ve api-v2 deploy edildikten hemen sonra, yeni user-panel yayına ÇIKMADAN önce " +
        "çalıştırın: yeni chat sayfası artık e-posta hesaplarını sunmuyor; önce orada kaydedilen " +
        "bir chat bloğu onları kopyalanmadan kaybedebilir."
    },
    {
      en:
        "A profile whose `emailSettings` was saved from the panel in the meantime is left alone — " +
        "the write only lands while the block is still missing — so a second run writes nothing.",
      tr:
        "Bu arada panelden `emailSettings` kaydedilmiş profile dokunulmaz — yazım yalnızca blok " +
        "hâlâ yokken uygulanır — bu yüzden ikinci çalıştırma hiçbir şey yazmaz."
    }
  ]
}

export default aiEmailSettings
